/* eslint-disable */
// This file was automatically generated and should not be edited.
// Generated from src/services/graphql/schemas and src/services/graphql operations.

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CountrySubdivisionCode: { input: any; output: any; }
  /** Unit of currency defined by a 3 character ISO 4217 Currency code */
  Currency: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Markdown: { input: any; output: any; }
};

export type AddUserAddressInput = {
  /** The address details to add for the user. */
  address: UserAddressInput;
};

export type AddUserAddressOutput = {
  __typename?: 'AddUserAddressOutput';
  /** The newly added user address. */
  address: UserAddress;
};

export type AssociatedItem = {
  __typename?: 'AssociatedItem';
  itemPartNumber: Scalars['ID']['output'];
};

/** Type representing button content. */
export type Button = {
  __typename?: 'Button';
  accText?: Maybe<Scalars['String']['output']>;
  lineOne?: Maybe<Scalars['String']['output']>;
  lineTwo?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CatalogRef = {
  __typename?: 'CatalogRef';
  /** The legacy ID */
  catalogEntryId: Scalars['ID']['output'];
  /** The Relay global unique ID */
  id: Scalars['ID']['output'];
  /** The part number (SKU) */
  partNumber: Scalars['ID']['output'];
  /** The PartNumber of the Parent PRODUCT if this is an ITEM, otherwise null */
  productPartNumber?: Maybe<Scalars['ID']['output']>;
  /** The typename of this SKU, such as `ITEM` or `PRODUCT` */
  recordType: Scalars['String']['output'];
};

/** The video information associated to the item */
export type CatalogVideo = {
  __typename?: 'CatalogVideo';
  /** The video url */
  url: Scalars['String']['output'];
};

/**
 * Connections provide the collected results for a given paged request in accordance with the Relay Specification.
 *
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 */
export type Connection = {
  edges?: Maybe<Array<Maybe<Edge>>>;
  pageInfo: PageInfo;
};

/** Type representing block of text content. */
export type Copy = {
  __typename?: 'Copy';
  alignment?: Maybe<Scalars['String']['output']>;
  richText?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  textStyle?: Maybe<Scalars['String']['output']>;
};

export type CurrentMonthExpiringRewards = {
  __typename?: 'CurrentMonthExpiringRewards';
  amount?: Maybe<Money>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
};

/**
 * Represents a subset or "page" of data, identified by a cursor. This cursor points to the identifier of the page's first
 * element. Service indicates if additional data is available a non-null value in the `next` attribute. Clients can access
 * this data by sending the same query with the `next` value in CursorPageRequestInput's `after` attribute.
 *
 * Cursor paged data is best used when the underlying data set changes frequently. See best practice docs for more info.
 */
export type CursorPage = {
  next?: Maybe<Scalars['ID']['output']>;
  previous?: Maybe<Scalars['ID']['output']>;
};

/**
 * Provides clients with a standardized way of requesting a set or "page" of data via cursor index. Setting
 * 'before' and 'after' to null is expected to fetch the latest set of data
 */
export type CursorPageRequestInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
};

/** Input for deleting an address. */
export type DeleteUserAddressInput = {
  /** Unique identifier for the address to delete. */
  addressId: Scalars['ID']['input'];
  /** Source entry point for the address deletion (e.g., ACCOUNT, CHECKOUT, SALES FORCE, etc). */
  entryPoint: Scalars['String']['input'];
};

export type DeleteUserAddressOutput = {
  __typename?: 'DeleteUserAddressOutput';
  /** The unique identifier of the deleted user address. */
  addressId: Scalars['ID']['output'];
};

export type DeliveryInstructions = {
  __typename?: 'DeliveryInstructions';
  /** Predefined delivery instruction that indicates where the package should be left if the recipient is not available. */
  instruction?: Maybe<Scalars['String']['output']>;
  /** The security code required for delivery access. */
  securityCode?: Maybe<Scalars['String']['output']>;
  /** Any additional special instructions for delivery personnel. */
  specialInstructions?: Maybe<Scalars['String']['output']>;
};

export type DeliveryInstructionsInput = {
  /**
   * Predefined delivery instruction that indicates where the package should be left if the recipient is not available.
   *
   * If "OT" (Other) is selected, the `specialInstructions` field must be provided.
   *
   * Allowed values:
   * - FD: Front Door
   * - BD: Back Door / Patio
   * - SD: Side Door
   * - GA: Garage
   * - ME: Main Entrance / Front Desk
   * - SG: Security / Guard Post
   * - AO: Apartment Office
   * - OT: Other
   * - null: No Preference
   */
  instruction?: InputMaybe<Scalars['String']['input']>;
  /** The security code required for delivery access. */
  securityCode?: InputMaybe<Scalars['String']['input']>;
  /** Any additional special instructions for delivery personnel. */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
};

/** Provides clients with a standardized way of requesting sort direction */
export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

/**
 * A type that is returned in list form by a connection type’s edges field is considered by this spec to be an Edge Type.
 * Edge types must be an “Object” as defined in the “Type System” section of the GraphQL Specification.
 *
 * Edges are the individual members of a paged request.
 *
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 */
export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

/** Type representing image content. */
export type Image = {
  __typename?: 'Image';
  accCaption?: Maybe<Scalars['String']['output']>;
  accLabel?: Maybe<Scalars['String']['output']>;
  altText?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  imageType?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  originalUrl?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type ImageData = {
  __typename?: 'ImageData';
  /** The image alt text */
  altText?: Maybe<Scalars['String']['output']>;
  /** The image assetType, this is a String-based Enum sourced from the DAM (Bynder) and MOE systems */
  assetType?: Maybe<Scalars['String']['output']>;
  /** The raw CDN Url for this image, as set by Retail Ops */
  url: Scalars['String']['output'];
};

export type Item = {
  __typename?: 'Item';
  /** The items with merchandising associations related to this item */
  associatedItems: ItemAssociations;
  /** The title of the bundle */
  bundleTitle?: Maybe<Scalars['String']['output']>;
  /** The item Catalog Entry ID */
  catalogEntryId: Scalars['ID']['output'];
  /** The count of individual pieces sold as this item. Correlates to Cumulus Attribute 402 Count */
  count?: Maybe<Scalars['String']['output']>;
  /**
   * This field is deprecated, use 'item.imageData' instead
   * @deprecated This field is deprecated. Use 'item.imageData' instead.
   */
  fullImage?: Maybe<Scalars['String']['output']>;
  /** The item's suggested autoship subscription frequency for healthcare SKUs */
  healthcareSuggestedSubscriptionFrequency?: Maybe<SubscriptionFrequency>;
  /** The Relay global unique ID */
  id: Scalars['ID']['output'];
  /** The images associated to this item; primaryImage is always the first, followed by secondary images */
  imageData: Array<ImageData>;
  /**
   * This field is deprecated and defaults to false always, use item.product.isCustomizable instead
   * @deprecated use item.product.isCustomizable instead
   */
  isCustomizable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This field is deprecated and defaults to false always, use item.product.isDonationGiftCard instead
   * @deprecated use item.product.isDonationGiftCard instead
   */
  isDonationGiftCard?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the item is allowed to have autoship/recurring orders */
  isSubscriptionAllowed: Scalars['Boolean']['output'];
  /** Mapping of item classifications and whether item falls under it */
  itemClassifications: ItemClassifications;
  /** The lifecycle states associated with this item */
  itemLifecycleStates: ItemLifecycleStates;
  /** The shipping information associated to this item */
  itemShipping?: Maybe<ItemShipping>;
  /** Loyalty Rewards Eligibilities for an item */
  loyaltyRewardsEligibilities?: Maybe<LoyaltyRewardsEligibilities>;
  /** The name of the item's manufacturer */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** The item product name */
  name?: Maybe<Scalars['String']['output']>;
  /** The item name, modified to remove the manufacturer name if prefixing the name */
  nameWithoutManufacturer?: Maybe<Scalars['String']['output']>;
  /** The item part number */
  partNumber: Scalars['ID']['output'];
  /** The item pdpSlug */
  pdpSlug?: Maybe<Scalars['String']['output']>;
  /** The item pdp url in format '/{pdpSlug}/dp/{catalogEntryId}' if pdpSlug is present, '/dp/{catalogEntryId}' if pdpSlug is not present */
  pdpUrl: Scalars['String']['output'];
  /** The plan type associated with this item */
  planType?: Maybe<Scalars['String']['output']>;
  /** The pricing unit of measure, such as "lb" or "oz". This is used to determine the price per unit for items sold in different quantities */
  pricingUnitOfMeasure: PricingUnitOfMeasure;
  /** The parent product of this item */
  product?: Maybe<Product>;
  /** The parent product of this item's part number */
  productPartNumber: Scalars['ID']['output'];
  /** size (if applicable) of item */
  size?: Maybe<Scalars['String']['output']>;
  /**
   * This field is deprecated, use 'item.imageData' instead
   * @deprecated This field is deprecated. Use 'item.imageData' instead.
   */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** The videos associated to this item */
  videos: Array<CatalogVideo>;
  /** Identifies the minimum/maximum weight limits for pets to use a medication. Used in conjunction with customer's pet profile to flag if a customer is trying to purchase a product that falls outside minimum/maximum weight thresholds. Matched with product.petType field to determine if a dog or cat medication */
  weightThreshold: WeightThreshold;
};

/** The merchandising associations for this item */
export type ItemAssociations = {
  __typename?: 'ItemAssociations';
  bundleEquivalentItems: Array<AssociatedItem>;
  replacementItem?: Maybe<AssociatedItem>;
};

export type ItemClassifications = {
  __typename?: 'ItemClassifications';
  /** Indicates if the item is a multi_sku or same_sku bundle type */
  isBundle: Scalars['Boolean']['output'];
  /** Denotes pharmacy items with additional regulatory controls above and beyond simple Rx, such as Gabapentin */
  isControlled: Scalars['Boolean']['output'];
  /** Indicates if the item is a multi_sku bundle type */
  isMultiSkuBundle: Scalars['Boolean']['output'];
  /** Indicates if the item is a same_sku bundle type */
  isSameSkuBundle: Scalars['Boolean']['output'];
  /** Indicates if the item is a vet diet item */
  isVetDiet: Scalars['Boolean']['output'];
};

export type ItemLifecycleStates = {
  __typename?: 'ItemLifecycleStates';
  /** Indicates if the item is discontinued */
  isDiscontinued: Scalars['Boolean']['output'];
  /** Indicates whether this individual item should be suppressed (hidden) from the PDP page. The items in a given product family may have different values for this field at any given time */
  isPdpSuppressed: Scalars['Boolean']['output'];
  /** Indicates if the item is published */
  isPublished: Scalars['Boolean']['output'];
};

export type ItemShipping = {
  __typename?: 'ItemShipping';
  /** The maximum number of days for Dropship items */
  maximumShippingDays: Scalars['Int']['output'];
  /** The minimum number of shipping days for Dropship items */
  minimumShippingDays: Scalars['Int']['output'];
};

/** The product key images used for iconography */
export type KeyImageIcon = {
  __typename?: 'KeyImageIcon';
  /** The product key image display name */
  displayName: Scalars['String']['output'];
  /** The product key image url */
  keyImageUrl: Scalars['String']['output'];
};

export type LoyaltyAvailableMembershipPlans = {
  __typename?: 'LoyaltyAvailableMembershipPlans';
  plans: Array<LoyaltyMembershipPlanTrajectory>;
};

export type LoyaltyBenefit = {
  __typename?: 'LoyaltyBenefit';
  benefitClaimType?: Maybe<LoyaltyBenefitClaimType>;
  /** @deprecated Use loyaltyBenefitName field for benefit names instead */
  benefitName?: Maybe<LoyaltyBenefitName>;
  claimStatus?: Maybe<LoyaltyBenefitClaimStatus>;
  endTimestamp: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  loyaltyBenefitName?: Maybe<Scalars['String']['output']>;
  memberExclusiveOfferUiData?: Maybe<MemberExclusiveOfferUiData>;
  promoIds?: Maybe<Array<Scalars['ID']['output']>>;
  promoOfferType?: Maybe<Scalars['String']['output']>;
  retargetingData?: Maybe<RetargetingData>;
  startTimestamp: Scalars['DateTime']['output'];
};

export enum LoyaltyBenefitClaimStatus {
  Claimed = 'CLAIMED',
  Expired = 'EXPIRED',
  /** @deprecated Not used as a claim status */
  InProgress = 'IN_PROGRESS',
  Unclaimed = 'UNCLAIMED'
}

export enum LoyaltyBenefitClaimType {
  Onetime = 'ONETIME',
  Recurring = 'RECURRING'
}

export enum LoyaltyBenefitName {
  CwavVideoUnlimited = 'CWAV_VIDEO_UNLIMITED',
  FleaTick_2025_03 = 'FLEA_TICK_2025_03',
  HolidayGiftcard_2024 = 'HOLIDAY_GIFTCARD_2024',
  Reward_1X = 'REWARD_1X',
  Reward_2X = 'REWARD_2X',
  SupplementDiscount = 'SUPPLEMENT_DISCOUNT'
}

export type LoyaltyBenefits = {
  __typename?: 'LoyaltyBenefits';
  benefits?: Maybe<Array<Maybe<LoyaltyBenefit>>>;
  customerId: Scalars['ID']['output'];
};

export type LoyaltyLifetimeSavings = {
  __typename?: 'LoyaltyLifetimeSavings';
  poisonHelplineSavings: Money;
  telemedicineSavings: Money;
};

export type LoyaltyMembership = Node & {
  __typename?: 'LoyaltyMembership';
  automaticRenewal?: Maybe<Scalars['Boolean']['output']>;
  createdTimestamp?: Maybe<Scalars['String']['output']>;
  currentMembershipStartTimestamp?: Maybe<Scalars['DateTime']['output']>;
  currentMonthExpiringRewards?: Maybe<CurrentMonthExpiringRewards>;
  customerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  cwavSavings?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  freeCwavAppointmentsRemaining?: Maybe<Scalars['Int']['output']>;
  freeShippingSavings?: Maybe<Scalars['String']['output']>;
  freeTrialEligible?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isOverCapLimit?: Maybe<Scalars['Boolean']['output']>;
  lifetimeTotalBenefitSavings?: Maybe<Money>;
  lifetimeTotalEarnedRewards?: Maybe<Money>;
  lifetimeTotalRedeemedRewards?: Maybe<Money>;
  memberExclusiveOffersSavings?: Maybe<Money>;
  membershipStatus?: Maybe<LoyaltyMembershipStatus>;
  membershipYearTotalSpendLimit?: Maybe<Money>;
  nextRenewalTimestamp?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentFrequency?: Maybe<LoyaltyPaymentFrequency>;
  paymentId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<LoyaltyPlanType>;
  redeemedRewards?: Maybe<Money>;
  rewardBalance?: Maybe<Scalars['String']['output']>;
  rewardsCap?: Maybe<LoyaltyRewardsCapDefinition>;
  savingsThreshold?: Maybe<Money>;
  suspensionReason?: Maybe<LoyaltySuspensionReason>;
  totalBenefitSavings?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  totalEarnedRewards?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  totalFreeCwavAppointments?: Maybe<Scalars['Int']['output']>;
  totalSpendCurrentMembershipYear?: Maybe<Money>;
  walletId?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyMembershipPlanTrajectory = {
  __typename?: 'LoyaltyMembershipPlanTrajectory';
  durationInDays?: Maybe<Scalars['Int']['output']>;
  nextChargedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  nextPlan?: Maybe<Scalars['String']['output']>;
  nextPrice?: Maybe<Money>;
  plan?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<LoyaltyPlanType>;
  price?: Maybe<Money>;
};

export enum LoyaltyMembershipStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Suspended = 'SUSPENDED'
}

export enum LoyaltyPaymentFrequency {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export type LoyaltyPlanDetails = {
  __typename?: 'LoyaltyPlanDetails';
  cancelByDate?: Maybe<Scalars['Date']['output']>;
  durationInDays: Scalars['Int']['output'];
  nextBillingDate: Scalars['Date']['output'];
  planType: LoyaltyPlanType;
  price: Money;
};

export enum LoyaltyPlanType {
  FreeTrial = 'FREE_TRIAL',
  Paid = 'PAID'
}

export type LoyaltyPreferredPayment = Node & {
  __typename?: 'LoyaltyPreferredPayment';
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  walletId?: Maybe<Scalars['String']['output']>;
};

export enum LoyaltyRewardCategory {
  LoyaltyHealthcareCredits = 'LOYALTY_HEALTHCARE_CREDITS',
  LoyaltyRewards = 'LOYALTY_REWARDS',
  VetAppointment = 'VET_APPOINTMENT'
}

export type LoyaltyRewardSummary = {
  __typename?: 'LoyaltyRewardSummary';
  currentBalance?: Maybe<Scalars['String']['output']>;
  expiredRewards?: Maybe<Scalars['String']['output']>;
  rewardCategory?: Maybe<LoyaltyRewardCategory>;
};

export type LoyaltyRewardsCapDefinition = {
  __typename?: 'LoyaltyRewardsCapDefinition';
  capType: LoyaltyRewardsCapType;
  limitAmount?: Maybe<Money>;
};

export enum LoyaltyRewardsCapType {
  EarnedRewards = 'EARNED_REWARDS',
  EligibleSpend = 'ELIGIBLE_SPEND'
}

export type LoyaltyRewardsCategoriesSummaries = Node & {
  __typename?: 'LoyaltyRewardsCategoriesSummaries';
  id: Scalars['ID']['output'];
  rewardCategories?: Maybe<Array<Maybe<LoyaltyRewardSummary>>>;
};

export type LoyaltyRewardsEligibilities = {
  __typename?: 'LoyaltyRewardsEligibilities';
  eligibilities: Array<LoyaltyRewardsEligibility>;
};

export type LoyaltyRewardsEligibility = {
  __typename?: 'LoyaltyRewardsEligibility';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  pdpAutoshipBodyMarkdown?: Maybe<Scalars['String']['output']>;
  pdpBuyOnceBodyMarkdown?: Maybe<Scalars['String']['output']>;
  pdpContextualUpsellAutoshipMarkdown?: Maybe<Scalars['String']['output']>;
  pdpContextualUpsellBuyOnceMarkdown?: Maybe<Scalars['String']['output']>;
  pdpHeadline?: Maybe<Scalars['String']['output']>;
  pdpItemRewardsHeadlineMarkdown?: Maybe<Scalars['String']['output']>;
};

export type LoyaltySignupSelectionInput = {
  frequency?: InputMaybe<LoyaltyPaymentFrequency>;
  isEnabled: Scalars['Boolean']['input'];
};

export type LoyaltySignupSelectionResponse = {
  __typename?: 'LoyaltySignupSelectionResponse';
  isEnabled: Scalars['Boolean']['output'];
  loyaltySignupSelection?: Maybe<LoyaltyPaymentFrequency>;
};

export enum LoyaltySuspensionReason {
  MembershipOrderBlocked = 'MEMBERSHIP_ORDER_BLOCKED',
  MembershipOrderManualRetriesExhausted = 'MEMBERSHIP_ORDER_MANUAL_RETRIES_EXHAUSTED',
  MembershipOrderPaymentDeclined = 'MEMBERSHIP_ORDER_PAYMENT_DECLINED',
  /** @deprecated Field no longer supported */
  MembershipOrderPreconditionsFailed = 'MEMBERSHIP_ORDER_PRECONDITIONS_FAILED',
  MembershipOrderPreconditionAddressIssue = 'MEMBERSHIP_ORDER_PRECONDITION_ADDRESS_ISSUE',
  MembershipOrderPreconditionIssue = 'MEMBERSHIP_ORDER_PRECONDITION_ISSUE',
  MembershipOrderPreconditionPaymentIssue = 'MEMBERSHIP_ORDER_PRECONDITION_PAYMENT_ISSUE'
}

export type LoyaltyUpsellLocations = {
  __typename?: 'LoyaltyUpsellLocations';
  locations: Array<Maybe<Scalars['String']['output']>>;
};

export type MemberExclusiveOfferAnalyticsVariant = {
  __typename?: 'MemberExclusiveOfferAnalyticsVariant';
  eventCategory: Scalars['String']['output'];
  eventLabels?: Maybe<Array<MemberExclusiveOfferEventLabel>>;
  groupType: Scalars['String']['output'];
  pageType: Scalars['String']['output'];
};

export type MemberExclusiveOfferCardPage = {
  __typename?: 'MemberExclusiveOfferCardPage';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  cta?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  descriptionMarkdown?: Maybe<Scalars['String']['output']>;
  headlineMarkdown?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  pageType: Scalars['String']['output'];
};

export type MemberExclusiveOfferContextualMessage = {
  __typename?: 'MemberExclusiveOfferContextualMessage';
  /** @deprecated Use messageMarkdown instead. */
  message?: Maybe<Scalars['String']['output']>;
  /** @deprecated Embed link text directly in messageMarkdown/subMessageMarkdown. */
  messageHyperlinkText?: Maybe<Scalars['String']['output']>;
  messageMarkdown?: Maybe<Scalars['String']['output']>;
  pageType: Scalars['String']['output'];
  /** @deprecated Use subMessageMarkdown instead. */
  subMessage?: Maybe<Scalars['String']['output']>;
  subMessageMarkdown?: Maybe<Scalars['String']['output']>;
};

export type MemberExclusiveOfferEventLabel = {
  __typename?: 'MemberExclusiveOfferEventLabel';
  eventKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MemberExclusiveOfferUiData = {
  __typename?: 'MemberExclusiveOfferUiData';
  analyticsConfigs?: Maybe<Array<MemberExclusiveOfferAnalyticsVariant>>;
  /** @deprecated Use cardPages(pageType) instead. */
  badgeLabel?: Maybe<Scalars['String']['output']>;
  cardPages?: Maybe<Array<MemberExclusiveOfferCardPage>>;
  contextualMessages?: Maybe<Array<MemberExclusiveOfferContextualMessage>>;
  /** @deprecated Use cardPages(pageType) instead. */
  cta?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cardPages(pageType) instead. */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cardPages(pageType).descriptionMarkdown instead. */
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cardPages(pageType) instead. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cardPages(pageType).headlineMarkdown instead. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use cardPages(pageType).headlineMarkdown instead. */
  title?: Maybe<Scalars['String']['output']>;
};


export type MemberExclusiveOfferUiDataAnalyticsConfigsArgs = {
  pageType?: InputMaybe<Scalars['String']['input']>;
};


export type MemberExclusiveOfferUiDataCardPagesArgs = {
  pageType?: InputMaybe<Scalars['String']['input']>;
};


export type MemberExclusiveOfferUiDataContextualMessagesArgs = {
  pageType?: InputMaybe<Scalars['String']['input']>;
};

/** Type representing the currency based measured units */
export type Money = {
  __typename?: 'Money';
  /**
   * Represents an amount of currency. Value uses the base unit of the specified currency type
   * E.g. dollars when code is "USD"
   */
  amount: Scalars['Float']['output'];
  /** Specifies the currency unit of this Money instance */
  currency: Scalars['Currency']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adds a new address for the currently authenticated user. */
  addUserAddress: AddUserAddressOutput;
  /** Deletes an address for the currently authenticated user. */
  deleteUserAddress: DeleteUserAddressOutput;
  setLoyaltySignupSelection?: Maybe<LoyaltySignupSelectionResponse>;
  /** Updates an existing address for the currently authenticated user. */
  updateUserAddress: UpdateUserAddressOutput;
};


export type MutationAddUserAddressArgs = {
  input: AddUserAddressInput;
};


export type MutationDeleteUserAddressArgs = {
  input: DeleteUserAddressInput;
};


export type MutationSetLoyaltySignupSelectionArgs = {
  input: LoyaltySignupSelectionInput;
};


export type MutationUpdateUserAddressArgs = {
  input: UpdateUserAddressInput;
};

/** Common interface for the Node object */
export type Node = {
  id: Scalars['ID']['output'];
};

/**
 * Represents a subset or "page" of data, identified by a numerical index.  Service indicates if additional data is available
 * via the `hasNextPage` attribute. Clients can access this data by sending the same query with an incremented page value
 * in the NumberedPageRequestInput.
 *
 * Numerically paged data is best used when the underlying data set does not change frequently. See best practice docs for more info
 */
export type NumberedPage = {
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

/** Provides clients with a standardized way of requesting a set or "page" of data via numerical index */
export type NumberedPageRequestInput = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
};

/** Order type - so loyalty subgraph can easily move over to order type in the future. */
export type Order = {
  __typename?: 'Order';
  id: Scalars['ID']['output'];
};

/**
 * Relay specification compliant type that provides information about the current result set of pages. Is used by clients
 * determine if there are results on either side of the given segment and the start and end cursors of the current request.
 *
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PricingUnitOfMeasure {
  Each = 'EACH',
  FluidOunce = 'FLUID_OUNCE',
  Gallon = 'GALLON',
  Gram = 'GRAM',
  Liter = 'LITER',
  Milliliter = 'MILLILITER',
  Ounce = 'OUNCE',
  Pill = 'PILL',
  Pound = 'POUND',
  Serving = 'SERVING',
  Unknown = 'UNKNOWN'
}

export type Product = {
  __typename?: 'Product';
  /** The caloric content */
  caloricContent?: Maybe<Scalars['String']['output']>;
  /** The product Catalog Entry ID */
  catalogEntryId: Scalars['ID']['output'];
  /** The product family's preferred SEO category to display in breadcrumbs */
  defaultBreadcrumb?: Maybe<Scalars['String']['output']>;
  /** The type of drug medication the product is classified as. Correlates to Cumulus Attribute 493 Count */
  drugType?: Maybe<Scalars['String']['output']>;
  /** The food flavor */
  foodFlavor?: Maybe<Scalars['String']['output']>;
  /** The Relay global unique ID */
  id: Scalars['ID']['output'];
  /** The ingredients */
  ingredients?: Maybe<Scalars['String']['output']>;
  /**
   * This field is deprecated. Use 'productFamilyClassifications.isCustomizable' instead.
   * @deprecated This field is deprecated. Use 'productFamilyClassifications.isCustomizable' instead.
   */
  isCustomizable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This field is deprecated. Use 'productFamilyClassifications.isDonationGiftCard' instead.
   * @deprecated This field is deprecated. Use 'productFamilyClassifications.isDonationGiftCard' instead.
   */
  isDonationGiftCard?: Maybe<Scalars['Boolean']['output']>;
  /** The item part numbers associated to this product */
  itemPartNumbers: Array<Scalars['ID']['output']>;
  /** The product keyBenefits */
  keyBenefits: Array<Scalars['String']['output']>;
  /** The product key image icons */
  keyImageIcons: Array<KeyImageIcon>;
  /** The product description */
  longDescription?: Maybe<Scalars['String']['output']>;
  /** The product name */
  name?: Maybe<Scalars['String']['output']>;
  /** The product family's preferred SEO meta description */
  pageMetaDescription?: Maybe<Scalars['String']['output']>;
  /** The products page title overridden for SEO */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** The product part number (SKU) */
  partNumber: Scalars['ID']['output'];
  /** The product pdpSlug */
  pdpSlug?: Maybe<Scalars['String']['output']>;
  /** The pet type */
  petType?: Maybe<Scalars['String']['output']>;
  /** The product preferable flavors */
  preferableFlavors: Array<Scalars['String']['output']>;
  /** The product family's classifications */
  productFamilyClassifications: ProductFamilyClassifications;
  /** The product family's pre-formatted descriptions */
  productFormattedDescriptions: ProductFormattedDescriptions;
  /** The product type */
  productType?: Maybe<Scalars['String']['output']>;
  /**
   * A list of top-level country sub-divisions (US states/districts/territories, Canadian provinces/territories, etc.)
   * where the product is not available for purchase because of subdivision-level regulations.
   */
  restrictedAvailability: Array<Scalars['CountrySubdivisionCode']['output']>;
};

export type ProductFamilyClassifications = {
  __typename?: 'ProductFamilyClassifications';
  /** Indicates if the product is a compounded medication */
  isCompound: Scalars['Boolean']['output'];
  /** Is this product customizable */
  isCustomizable: Scalars['Boolean']['output'];
  /** Indicates if this product is a donation gift card */
  isDonationGiftCard: Scalars['Boolean']['output'];
  /** Indicates if this product is a gift card */
  isGiftCard: Scalars['Boolean']['output'];
  /** Indicates if this product family contains loyalty items */
  isLoyaltyMembership: Scalars['Boolean']['output'];
  /** Indicates if this product is a chewy fresh product */
  isPbFresh: Scalars['Boolean']['output'];
  /** Indicates if the product is a pharmacy product */
  isPharmacy: Scalars['Boolean']['output'];
  /** Indicates if this product is a privateLabel product. Powers the "By Chewy" messaging/badging */
  isPrivateLabel: Scalars['Boolean']['output'];
  /** Indicates if this product is a promotion gift card */
  isPromoGiftCard: Scalars['Boolean']['output'];
  /** Indicates if this product requires refrigeration and specialized fulfillment */
  isRefrigerated: Scalars['Boolean']['output'];
};

export type ProductFormattedDescriptions = {
  __typename?: 'ProductFormattedDescriptions';
  /** The product family's feeding instructions */
  feedingInstructions?: Maybe<Scalars['Markdown']['output']>;
  /** The product family's frequently asked questions */
  frequentlyAskedQuestions?: Maybe<Scalars['Markdown']['output']>;
  /** The product family's guaranteed analysis */
  guaranteedAnalysis?: Maybe<Scalars['Markdown']['output']>;
  /** The product family's transition instructions */
  transitionInstructions?: Maybe<Scalars['Markdown']['output']>;
};

export type Query = {
  __typename?: 'Query';
  catalogRef?: Maybe<CatalogRef>;
  item?: Maybe<Item>;
  loyaltyAvailableMembershipPlans?: Maybe<LoyaltyAvailableMembershipPlans>;
  loyaltyBenefits?: Maybe<LoyaltyBenefits>;
  loyaltyEligibleUpsellLocations?: Maybe<LoyaltyUpsellLocations>;
  loyaltyLifetimeSavings?: Maybe<LoyaltyLifetimeSavings>;
  loyaltyMembership?: Maybe<LoyaltyMembership>;
  /** @deprecated Use loyaltyAvailableMembershipPlans instead */
  loyaltyMembershipPlan?: Maybe<LoyaltyPlanDetails>;
  loyaltyPreferredPayment?: Maybe<LoyaltyPreferredPayment>;
  loyaltyRewardsCategoriesSummaries?: Maybe<LoyaltyRewardsCategoriesSummaries>;
  /** @deprecated Use loyaltySignupSelectionResponse instead */
  loyaltySignupSelection?: Maybe<LoyaltyPaymentFrequency>;
  loyaltySignupSelectionResponse?: Maybe<LoyaltySignupSelectionResponse>;
  product?: Maybe<Product>;
  resolvePartNumber?: Maybe<CatalogRef>;
  telemedicineEligible: Scalars['Boolean']['output'];
  /** Returns the currently authenticated user. */
  user?: Maybe<User>;
  /** Returns a list of currently authenticated user addresses, optionally filtered by specific criteria. */
  userAddresses?: Maybe<Array<UserAddress>>;
};


export type QueryCatalogRefArgs = {
  partNumber: Scalars['ID']['input'];
};


export type QueryItemArgs = {
  partNumber: Scalars['ID']['input'];
};


export type QueryLoyaltyMembershipArgs = {
  using?: InputMaybe<TotalBenefitRewardSource>;
};


export type QueryProductArgs = {
  partNumber: Scalars['ID']['input'];
};


export type QueryResolvePartNumberArgs = {
  catalogEntryId: Scalars['ID']['input'];
};


export type QueryUserAddressesArgs = {
  filter?: InputMaybe<UserAddressFilter>;
};

export type RetargetingData = {
  __typename?: 'RetargetingData';
  sourceItem: Item;
  sourceOrder: Order;
  targetItem: Item;
};

export type SubscriptionFrequency = {
  __typename?: 'SubscriptionFrequency';
  unit: SubscriptionFrequencyUnit;
  value: Scalars['Int']['output'];
};

export enum SubscriptionFrequencyUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum TotalBenefitRewardSource {
  /** @deprecated Field no longer supported */
  EarnedRewards = 'EARNED_REWARDS',
  RedeemedRewards = 'REDEEMED_REWARDS'
}

export type UpdateUserAddressInput = {
  /** The updated address details. */
  address: UserAddressInput;
  /** Unique identifier for the address to update. */
  addressId: Scalars['ID']['input'];
};

export type UpdateUserAddressOutput = {
  __typename?: 'UpdateUserAddressOutput';
  /** The updated user address. */
  address: UserAddress;
};

export type User = {
  __typename?: 'User';
  /** The user's addresses, optionally filtered by specific criteria. */
  addresses?: Maybe<Array<UserAddress>>;
  /** The user's full display name. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the user. */
  id: Scalars['ID']['output'];
  /** Primary email address used for contacting the user. */
  primaryContactEmail?: Maybe<Scalars['String']['output']>;
};


export type UserAddressesArgs = {
  filter?: InputMaybe<UserAddressFilter>;
};

export type UserAddress = {
  __typename?: 'UserAddress';
  /** City for this address. */
  city?: Maybe<Scalars['String']['output']>;
  /** Two-letter ISO country code representing the address location. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Optional delivery instructions for this address. */
  deliveryInstructions?: Maybe<DeliveryInstructions>;
  /** Full name associated with this address (e.g., recipient name). */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the user address. */
  id: Scalars['ID']['output'];
  /** Phone number associated with this address. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Postal or ZIP code for this address. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this address is the user's primary address. */
  primary?: Maybe<Scalars['Boolean']['output']>;
  /** State, province, or region for this address. */
  state?: Maybe<Scalars['String']['output']>;
  /** First line of the street address (e.g., building number and street). */
  street1?: Maybe<Scalars['String']['output']>;
  /** Second line of the street address (e.g., apartment, suite, or unit). */
  street2?: Maybe<Scalars['String']['output']>;
};

export type UserAddressFilter = {
  /** Filter results to only include addresses marked as primary. */
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAddressInput = {
  /** City for this address. */
  city: Scalars['String']['input'];
  /** Two-letter ISO country code representing the address location. */
  countryCode: Scalars['String']['input'];
  /** Indicates whether this address is a customer override address. Not the suggested by AVS. */
  customerOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional delivery instructions for this address. */
  deliveryInstructions?: InputMaybe<DeliveryInstructionsInput>;
  /** Source entry point for the address (e.g., ACCOUNT, CHECKOUT, SALES FORCE, etc). */
  entryPoint: Scalars['String']['input'];
  /** Full name associated with this address (e.g., recipient name). */
  fullName: Scalars['String']['input'];
  /** Phone number associated with this address. */
  phoneNumber: Scalars['String']['input'];
  /** Postal or ZIP code for this address. */
  postalCode: Scalars['String']['input'];
  /** Indicates whether this address is the user's primary address. */
  primary: Scalars['Boolean']['input'];
  /** State, province, or region for this address. */
  state: Scalars['String']['input'];
  /** First line of the street address (e.g., building number and street). */
  street1: Scalars['String']['input'];
  /** Second line of the street address (e.g., apartment, suite, or unit). */
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type Weight = {
  __typename?: 'Weight';
  unit: WeightUnit;
  value: Scalars['Float']['output'];
};

/** Provides a weight limit range for medication items. Both fields may be null if weight thresholds are unavailable or unspecified for the medication. */
export type WeightThreshold = {
  __typename?: 'WeightThreshold';
  /** Identifies the maximum required weight for cats/dogs to use a medication. */
  maximumWeight?: Maybe<Weight>;
  /** Identifies the minimum required weight for cats/dogs to use a medication. */
  minimumWeight?: Maybe<Weight>;
};

export enum WeightUnit {
  Kg = 'KG',
  Lb = 'LB',
  Oz = 'OZ'
}

export type AvailableMembershipPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableMembershipPlansQuery = { __typename?: 'Query', loyaltyAvailableMembershipPlans?: { __typename?: 'LoyaltyAvailableMembershipPlans', plans: Array<{ __typename?: 'LoyaltyMembershipPlanTrajectory', plan?: string | null, planType?: LoyaltyPlanType | null, durationInDays?: number | null, nextPlan?: string | null, nextChargedTimestamp?: string | null, price?: { __typename?: 'Money', amount: number, currency: string } | null, nextPrice?: { __typename?: 'Money', amount: number, currency: string } | null }> } | null };

export type CurrentUserFullNameQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserFullNameQuery = { __typename?: 'Query', user?: { __typename?: 'User', fullName?: string | null } | null };

export type ItemByPartNumberQueryVariables = Exact<{
  partNumber: Scalars['ID']['input'];
}>;


export type ItemByPartNumberQuery = { __typename?: 'Query', item?: { __typename?: 'Item', partNumber: string, name?: string | null, thumbnail?: string | null, fullImage?: string | null, pdpSlug?: string | null, catalogEntryId: string } | null };

export type LoyaltyLifetimeSavingsQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyLifetimeSavingsQuery = { __typename?: 'Query', loyaltyLifetimeSavings?: { __typename?: 'LoyaltyLifetimeSavings', telemedicineSavings: { __typename?: 'Money', amount: number }, poisonHelplineSavings: { __typename?: 'Money', amount: number } } | null };

export type EligibilityQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibilityQueryQuery = { __typename?: 'Query', loyaltyEligibleUpsellLocations?: { __typename?: 'LoyaltyUpsellLocations', locations: Array<string | null> } | null };

export type MembershipPreviewMembershipStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MembershipPreviewMembershipStatusQuery = { __typename?: 'Query', loyaltyMembership?: { __typename?: 'LoyaltyMembership', customerId?: string | null, membershipStatus?: LoyaltyMembershipStatus | null } | null };

export type PrimaryAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type PrimaryAddressQuery = { __typename?: 'Query', userAddresses?: Array<{ __typename?: 'UserAddress', id: string, fullName?: string | null, primary?: boolean | null, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, countryCode?: string | null }> | null };

export type TelemedicineEligibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type TelemedicineEligibilityQuery = { __typename?: 'Query', telemedicineEligible: boolean };


export const AvailableMembershipPlansDocument = gql`
    query AvailableMembershipPlans {
  loyaltyAvailableMembershipPlans {
    plans {
      plan
      planType
      durationInDays
      price {
        amount
        currency
      }
      nextPlan
      nextPrice {
        amount
        currency
      }
      nextChargedTimestamp
    }
  }
}
    `;

/**
 * __useAvailableMembershipPlansQuery__
 *
 * To run a query within a React component, call `useAvailableMembershipPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableMembershipPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableMembershipPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableMembershipPlansQuery(baseOptions?: Apollo.QueryHookOptions<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>(AvailableMembershipPlansDocument, options);
      }
export function useAvailableMembershipPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>(AvailableMembershipPlansDocument, options);
        }
// @ts-ignore
export function useAvailableMembershipPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>): Apollo.UseSuspenseQueryResult<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>;
export function useAvailableMembershipPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>): Apollo.UseSuspenseQueryResult<AvailableMembershipPlansQuery | undefined, AvailableMembershipPlansQueryVariables>;
export function useAvailableMembershipPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>(AvailableMembershipPlansDocument, options);
        }
export type AvailableMembershipPlansQueryHookResult = ReturnType<typeof useAvailableMembershipPlansQuery>;
export type AvailableMembershipPlansLazyQueryHookResult = ReturnType<typeof useAvailableMembershipPlansLazyQuery>;
export type AvailableMembershipPlansSuspenseQueryHookResult = ReturnType<typeof useAvailableMembershipPlansSuspenseQuery>;
export type AvailableMembershipPlansQueryResult = Apollo.QueryResult<AvailableMembershipPlansQuery, AvailableMembershipPlansQueryVariables>;
export const CurrentUserFullNameDocument = gql`
    query CurrentUserFullName {
  user {
    fullName
  }
}
    `;

/**
 * __useCurrentUserFullNameQuery__
 *
 * To run a query within a React component, call `useCurrentUserFullNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserFullNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserFullNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserFullNameQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>(CurrentUserFullNameDocument, options);
      }
export function useCurrentUserFullNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>(CurrentUserFullNameDocument, options);
        }
// @ts-ignore
export function useCurrentUserFullNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>;
export function useCurrentUserFullNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserFullNameQuery | undefined, CurrentUserFullNameQueryVariables>;
export function useCurrentUserFullNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>(CurrentUserFullNameDocument, options);
        }
export type CurrentUserFullNameQueryHookResult = ReturnType<typeof useCurrentUserFullNameQuery>;
export type CurrentUserFullNameLazyQueryHookResult = ReturnType<typeof useCurrentUserFullNameLazyQuery>;
export type CurrentUserFullNameSuspenseQueryHookResult = ReturnType<typeof useCurrentUserFullNameSuspenseQuery>;
export type CurrentUserFullNameQueryResult = Apollo.QueryResult<CurrentUserFullNameQuery, CurrentUserFullNameQueryVariables>;
export const ItemByPartNumberDocument = gql`
    query ItemByPartNumber($partNumber: ID!) {
  item(partNumber: $partNumber) {
    partNumber
    name
    thumbnail
    fullImage
    pdpSlug
    catalogEntryId
  }
}
    `;

/**
 * __useItemByPartNumberQuery__
 *
 * To run a query within a React component, call `useItemByPartNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemByPartNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemByPartNumberQuery({
 *   variables: {
 *      partNumber: // value for 'partNumber'
 *   },
 * });
 */
export function useItemByPartNumberQuery(baseOptions: Apollo.QueryHookOptions<ItemByPartNumberQuery, ItemByPartNumberQueryVariables> & ({ variables: ItemByPartNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>(ItemByPartNumberDocument, options);
      }
export function useItemByPartNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>(ItemByPartNumberDocument, options);
        }
// @ts-ignore
export function useItemByPartNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>): Apollo.UseSuspenseQueryResult<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>;
export function useItemByPartNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>): Apollo.UseSuspenseQueryResult<ItemByPartNumberQuery | undefined, ItemByPartNumberQueryVariables>;
export function useItemByPartNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>(ItemByPartNumberDocument, options);
        }
export type ItemByPartNumberQueryHookResult = ReturnType<typeof useItemByPartNumberQuery>;
export type ItemByPartNumberLazyQueryHookResult = ReturnType<typeof useItemByPartNumberLazyQuery>;
export type ItemByPartNumberSuspenseQueryHookResult = ReturnType<typeof useItemByPartNumberSuspenseQuery>;
export type ItemByPartNumberQueryResult = Apollo.QueryResult<ItemByPartNumberQuery, ItemByPartNumberQueryVariables>;
export const LoyaltyLifetimeSavingsDocument = gql`
    query LoyaltyLifetimeSavings {
  loyaltyLifetimeSavings {
    telemedicineSavings {
      amount
    }
    poisonHelplineSavings {
      amount
    }
  }
}
    `;

/**
 * __useLoyaltyLifetimeSavingsQuery__
 *
 * To run a query within a React component, call `useLoyaltyLifetimeSavingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyLifetimeSavingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyLifetimeSavingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyLifetimeSavingsQuery(baseOptions?: Apollo.QueryHookOptions<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>(LoyaltyLifetimeSavingsDocument, options);
      }
export function useLoyaltyLifetimeSavingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>(LoyaltyLifetimeSavingsDocument, options);
        }
// @ts-ignore
export function useLoyaltyLifetimeSavingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>): Apollo.UseSuspenseQueryResult<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>;
export function useLoyaltyLifetimeSavingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>): Apollo.UseSuspenseQueryResult<LoyaltyLifetimeSavingsQuery | undefined, LoyaltyLifetimeSavingsQueryVariables>;
export function useLoyaltyLifetimeSavingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>(LoyaltyLifetimeSavingsDocument, options);
        }
export type LoyaltyLifetimeSavingsQueryHookResult = ReturnType<typeof useLoyaltyLifetimeSavingsQuery>;
export type LoyaltyLifetimeSavingsLazyQueryHookResult = ReturnType<typeof useLoyaltyLifetimeSavingsLazyQuery>;
export type LoyaltyLifetimeSavingsSuspenseQueryHookResult = ReturnType<typeof useLoyaltyLifetimeSavingsSuspenseQuery>;
export type LoyaltyLifetimeSavingsQueryResult = Apollo.QueryResult<LoyaltyLifetimeSavingsQuery, LoyaltyLifetimeSavingsQueryVariables>;
export const EligibilityQueryDocument = gql`
    query EligibilityQuery {
  loyaltyEligibleUpsellLocations {
    locations
  }
}
    `;

/**
 * __useEligibilityQueryQuery__
 *
 * To run a query within a React component, call `useEligibilityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibilityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibilityQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useEligibilityQueryQuery(baseOptions?: Apollo.QueryHookOptions<EligibilityQueryQuery, EligibilityQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibilityQueryQuery, EligibilityQueryQueryVariables>(EligibilityQueryDocument, options);
      }
export function useEligibilityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibilityQueryQuery, EligibilityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibilityQueryQuery, EligibilityQueryQueryVariables>(EligibilityQueryDocument, options);
        }
// @ts-ignore
export function useEligibilityQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EligibilityQueryQuery, EligibilityQueryQueryVariables>): Apollo.UseSuspenseQueryResult<EligibilityQueryQuery, EligibilityQueryQueryVariables>;
export function useEligibilityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EligibilityQueryQuery, EligibilityQueryQueryVariables>): Apollo.UseSuspenseQueryResult<EligibilityQueryQuery | undefined, EligibilityQueryQueryVariables>;
export function useEligibilityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EligibilityQueryQuery, EligibilityQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EligibilityQueryQuery, EligibilityQueryQueryVariables>(EligibilityQueryDocument, options);
        }
export type EligibilityQueryQueryHookResult = ReturnType<typeof useEligibilityQueryQuery>;
export type EligibilityQueryLazyQueryHookResult = ReturnType<typeof useEligibilityQueryLazyQuery>;
export type EligibilityQuerySuspenseQueryHookResult = ReturnType<typeof useEligibilityQuerySuspenseQuery>;
export type EligibilityQueryQueryResult = Apollo.QueryResult<EligibilityQueryQuery, EligibilityQueryQueryVariables>;
export const MembershipPreviewMembershipStatusDocument = gql`
    query MembershipPreviewMembershipStatus {
  loyaltyMembership {
    customerId
    membershipStatus
  }
}
    `;

/**
 * __useMembershipPreviewMembershipStatusQuery__
 *
 * To run a query within a React component, call `useMembershipPreviewMembershipStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipPreviewMembershipStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipPreviewMembershipStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipPreviewMembershipStatusQuery(baseOptions?: Apollo.QueryHookOptions<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>(MembershipPreviewMembershipStatusDocument, options);
      }
export function useMembershipPreviewMembershipStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>(MembershipPreviewMembershipStatusDocument, options);
        }
// @ts-ignore
export function useMembershipPreviewMembershipStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>;
export function useMembershipPreviewMembershipStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>): Apollo.UseSuspenseQueryResult<MembershipPreviewMembershipStatusQuery | undefined, MembershipPreviewMembershipStatusQueryVariables>;
export function useMembershipPreviewMembershipStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>(MembershipPreviewMembershipStatusDocument, options);
        }
export type MembershipPreviewMembershipStatusQueryHookResult = ReturnType<typeof useMembershipPreviewMembershipStatusQuery>;
export type MembershipPreviewMembershipStatusLazyQueryHookResult = ReturnType<typeof useMembershipPreviewMembershipStatusLazyQuery>;
export type MembershipPreviewMembershipStatusSuspenseQueryHookResult = ReturnType<typeof useMembershipPreviewMembershipStatusSuspenseQuery>;
export type MembershipPreviewMembershipStatusQueryResult = Apollo.QueryResult<MembershipPreviewMembershipStatusQuery, MembershipPreviewMembershipStatusQueryVariables>;
export const PrimaryAddressDocument = gql`
    query PrimaryAddress {
  userAddresses(filter: {primary: true}) {
    id
    fullName
    primary
    street1
    street2
    city
    state
    postalCode
    countryCode
  }
}
    `;

/**
 * __usePrimaryAddressQuery__
 *
 * To run a query within a React component, call `usePrimaryAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrimaryAddressQuery(baseOptions?: Apollo.QueryHookOptions<PrimaryAddressQuery, PrimaryAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimaryAddressQuery, PrimaryAddressQueryVariables>(PrimaryAddressDocument, options);
      }
export function usePrimaryAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimaryAddressQuery, PrimaryAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimaryAddressQuery, PrimaryAddressQueryVariables>(PrimaryAddressDocument, options);
        }
// @ts-ignore
export function usePrimaryAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PrimaryAddressQuery, PrimaryAddressQueryVariables>): Apollo.UseSuspenseQueryResult<PrimaryAddressQuery, PrimaryAddressQueryVariables>;
export function usePrimaryAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrimaryAddressQuery, PrimaryAddressQueryVariables>): Apollo.UseSuspenseQueryResult<PrimaryAddressQuery | undefined, PrimaryAddressQueryVariables>;
export function usePrimaryAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrimaryAddressQuery, PrimaryAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrimaryAddressQuery, PrimaryAddressQueryVariables>(PrimaryAddressDocument, options);
        }
export type PrimaryAddressQueryHookResult = ReturnType<typeof usePrimaryAddressQuery>;
export type PrimaryAddressLazyQueryHookResult = ReturnType<typeof usePrimaryAddressLazyQuery>;
export type PrimaryAddressSuspenseQueryHookResult = ReturnType<typeof usePrimaryAddressSuspenseQuery>;
export type PrimaryAddressQueryResult = Apollo.QueryResult<PrimaryAddressQuery, PrimaryAddressQueryVariables>;
export const TelemedicineEligibilityDocument = gql`
    query TelemedicineEligibility {
  telemedicineEligible
}
    `;

/**
 * __useTelemedicineEligibilityQuery__
 *
 * To run a query within a React component, call `useTelemedicineEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelemedicineEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelemedicineEligibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useTelemedicineEligibilityQuery(baseOptions?: Apollo.QueryHookOptions<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>(TelemedicineEligibilityDocument, options);
      }
export function useTelemedicineEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>(TelemedicineEligibilityDocument, options);
        }
// @ts-ignore
export function useTelemedicineEligibilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>;
export function useTelemedicineEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>): Apollo.UseSuspenseQueryResult<TelemedicineEligibilityQuery | undefined, TelemedicineEligibilityQueryVariables>;
export function useTelemedicineEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>(TelemedicineEligibilityDocument, options);
        }
export type TelemedicineEligibilityQueryHookResult = ReturnType<typeof useTelemedicineEligibilityQuery>;
export type TelemedicineEligibilityLazyQueryHookResult = ReturnType<typeof useTelemedicineEligibilityLazyQuery>;
export type TelemedicineEligibilitySuspenseQueryHookResult = ReturnType<typeof useTelemedicineEligibilitySuspenseQuery>;
export type TelemedicineEligibilityQueryResult = Apollo.QueryResult<TelemedicineEligibilityQuery, TelemedicineEligibilityQueryVariables>;